import styled from "styled-components";

const StatusIcon = styled.img``;

export default StatusIcon;
